<template>
  <v-container fluid>

    <v-card v-if="facility" class="mx-auto" flat color="#fafafa">
      <v-row>
        <v-col v-if="hasAccess('DASHBOARD_MICROGRID')" cols="12" md="8" >
          <v-card class="pa-2" flat>
              <!-- toolbar : working icons right  ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
              <v-toolbar flat>
                <v-toolbar-title class="text-uppercase body-1 font-weight-medium">Your Current Configuration</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>

                <!-- guidance -->
                <v-tooltip top color="blue">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      @click="$_GoTo_PATH('/operate/guidance')"
                      fab
                      small
                      color="blue"
                      dark
                      elevation-4
                      mr-4 pr-4
                    >
                      <v-icon medium color="white">mdi-state-machine</v-icon>
                    </v-btn>
                  </template>
                  <span class="white--text font-weight-bold body-2">View Today's Guidance</span>
                </v-tooltip>
                <!-- simulate -->
                <v-tooltip top color="light-green">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      @click="$_GoTo_PATH('/demo/engine')"
                      fab
                      small
                      color="light-green"
                      dark
                      elevation-4
                      mr-4
                    >
                      <v-icon medium color="white">mdi-strategy</v-icon>
                    </v-btn>
                  </template>
                  <span class="white--text font-weight-bold body-2">Run Microgrid Simulations</span>
                </v-tooltip>

                <!-- edit -->
                <!-- 
                <v-tooltip
                  top
                  color="orange">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      fab
                      small
                      color="orange"
                      dark
                      elevation-4                              
                    >
                      <v-icon medium>edit</v-icon>
                    </v-btn>
                  </template>
                  <span class="white--text font-weight-bold body-2"
                    >Modify Microgrid</span
                  >
                </v-tooltip> -->
              
              </v-toolbar>

              <v-divider></v-divider>

              <!-- internal assets -->
              <v-list-item v-for="(item,i) in internalSupply" :key="`1-${i}`">
                  <v-list-item-icon>
                      <v-img :src="genImg(item.key)" class="pr-1" width="60px"></v-img>
                  </v-list-item-icon>
                  <v-list-item-title>{{ item.name }} ( {{ item.title }} )</v-list-item-title>
                  <div class="flex-grow-1"></div>
                  <v-list-item-title class="text-right justify-end">{{ item.value }} {{ item.unit }}</v-list-item-title>
              </v-list-item>

              <!-- internal asset totals -->
              <v-row align="center" no-gutters>
                <v-col v-for="(total, o) in internalTotals" :key="`2-${o}`">
                  <v-card
                      color="indigo lighten-5"
                      class="d-flex justify-center mb-6"
                      flat
                      tile
                      >
                      <h4 class="font-weight-bold text-uppercase text-center">
                          {{ total.name }}
                          <br/>
                          <span class="subheading">
                              {{ total.value | num }}
                              <span class="caption">{{ total.unit }}</span>
                          </span>
                      </h4>
                  </v-card>
                </v-col>
              </v-row>

              <!-- external assets -->
              <v-list-item v-for="(item,t) in externalSupply" :key="`3-${t}`">
                  <v-list-item-icon>
                      <v-img :src="genImg(item.key)" class="pr-1" width="40px"></v-img>
                  </v-list-item-icon>
                  <v-list-item-title>{{ item.name }} ( {{ item.title }} )</v-list-item-title>
                  <div class="flex-grow-1"></div>
                  <v-list-item-title class="text-right justify-end">{{ item.value }} {{ item.unit }}</v-list-item-title>
              </v-list-item>

              <!-- external asset totals -->
              <v-row align="center" no-gutters>
                <v-col v-for="(total, k) in externalTotals" :key="`4-${k}`">
                  <v-card
                      color="indigo lighten-5"
                      class="d-flex justify-center mb-6"
                      flat
                      tile
                      >
                      <h4 class="font-weight-bold text-uppercase text-center">
                          {{ total.name }}
                          <br/>
                          <span class="subheading">
                              {{ total.value | num }}
                              <span class="caption">{{ total.unit }}</span>
                          </span>
                      </h4>
                  </v-card>
                </v-col>
            </v-row>
          </v-card>
        </v-col>
        
        <!-- meta data -->
        <v-col cols="6" md="4">
          <v-card v-if="facility" flat class="pa-2 ma-3" color="#fafafa">
              <h3 class="title font-weight-bold">Facility</h3>
              {{ getFacilityName }} <br />
              {{ getFacilityAddress }} &nbsp;&nbsp;{{ getFacilityCityStateZip }}
          </v-card>

          <v-divider/>
          <v-card v-if="facility" flat class="pa-2 ma-3" color="#fafafa">
              <h3 class="title font-weight-bold">Utility</h3>
              {{ getUtilityName }}
            </v-card>

          <v-divider/>
          <v-card v-if="facility" flat class="pa-2 ma-3" color="#fafafa">
              <h3 class="title font-weight-bold">ISO</h3>
              {{ getIsoName }}
            </v-card>

          <v-divider/>
          <v-card v-if="facility && programs" flat class="pa-2 ma-3" color="#fafafa">
              <h3 class="title font-weight-bold">Rate Class</h3>
              <span v-for="(program, p) in getPrograms" :key="p">
                {{ program.description }}<br />
              </span>
            </v-card>

        </v-col>
      </v-row>
    </v-card>

    <!-- dialog -->
    <v-dialog
      v-if="!facility"
      v-model="multiFacilityDialog"
      persistent
      max-width="500">
      <v-form ref="form" v-model="facilitySelectValid">
        <v-card>
          <v-card-title class="headline">Select Facility</v-card-title>
          <v-card-text>
            <p class="text-left">
              This account has multiple facilities, please select one:
            </p>
            <v-select
              :items="facilities"
              :rules="[v => !!v || 'Facility is required']"
              v-model="selectedFacilityId"
              item-text="description"
              item-value="facility_id"
              required
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="selectFacility">Assign</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

  </v-container>
</template>
<script>
import FacilityService from '@/services/FacilityService'
import { mapGetters, mapState, mapMutations } from 'vuex'
export default {
  name: 'Home',
  data() {
    return {
      facilitySelectValid: false,
      facilities: [],
      programs: [],
      selectedFacilityId: '',
      multiFacilityDialog: false,

      // for demo, someday will be a component
      totalsSolar: 1992,
      totalsWind: 0,
      totalsStorage: 0,
      totalsGeneration: 4940,
      totalsDemandMgmt: 1100,

      totalsInternal: 8032,
      totalsExternal: 4194,

      externalSupplyTotals: {
        peakDemandKw: 4194,
        loadFactor: 60.32,
        annualUsageKw: 22164172,
        costKwh: 0.06157
      },

      externalSupply: [
        {
          component_id: 4,
          name: 'Grid',
          title: 'External Supply',
          key: 'external',
          value: 4194,
          unit: 'kW'
        }
      ],
      externalTotals: [
          {
              name: 'annual usage',
              value: 22164172,
              unit: 'kWh'
          },
          {
              name: 'load factor',
              value: 60.32,
              unit: '%'
          },
          {
              name: 'cost / kWh',
              value: 0.06157,
              unit: ''
          }
      ],
      internalSupply: [
        {
          component_id: 1,
          name: 'CoGen Main',
          title: 'Generation',
          key: 'generation',
          value: 4940,
          unit: 'kW'
        },
        {
          component_id: 2,
          name: 'Solar #1 - West',
          title: 'Solar',
          key: 'solar',
          value: 1380,
          unit: 'kW'
        },
        {
          component_id: 3,
          name: 'Solar #2 - South',
          title: 'Solar',
          key: 'solar',
          value: 612,
          unit: 'kW'
        },
        {
          component_id: 6,
          name: 'Chillers - Load Shift',
          title: 'Demand Mgmt',
          key: 'demand_mgmt',
          value: 1100,
          unit: 'kW'
        }
      ],
      internalTotals: [
          {
              name: 'solar',
              value: 1992,
              unit: 'kW'
          },
          {
              name: 'wind',
              value: 1992,
              unit: 'kW'
          },
          {
              name: 'generation',
              value: 1992,
              unit: 'kW'
          },
          {
              name: 'storage',
              value: 1992,
              unit: 'kW'
          },
          {
              name: 'demand mgmt',
              value: 1992,
              unit: 'kW'
          }
      ]

    }
  },

  computed: {
    ...mapState(['facility', 'utility', 'iso', 'facilityThreshold']),
    ...mapGetters([
      'getFacilityId',
      'getFacilityName',
      'getFacilityAddress',
      'getFacilityCityStateZip',
      'getFacilityTimezone',
      'getPrevailingTimezone',
      'getUtilityName',
      'getPrograms',
      'getIsoName',
      'hasAccess'
    ])
  },
  created() {
    this.fetchFacilities()
  },
  filters: {
    units(value) {
      if (value === 'currency') return
      return value
    },
    num(value) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        currency: 'USD',
        minimumFractionDigits: 0
      })
      return formatter.format(value)
    },
    values(value) {
      if (value.unit == 'currency') {
        return '$' + value.value
      }
      return value.value
    }
  },
  methods: {
    ...mapMutations(['SET_FACILITIES']),
    fetchFacilities() {
      FacilityService.getFacilities()
        .then(response => {
          this.facilities = response.data
          this.SET_FACILITIES({ facilities: this.facilities })
          switch (this.facilities.length) {
            case 0:
              this.$toast.warning("No facilities associated with this account.", { timeout: false })
              break
            case 1:
              this.$store.dispatch('changeFacility', { facility: this.facilities[0] })
              break
            default:
              this.multiFacilityDialog = true
          }
        })
        .catch(error => {
           this.$toast.error("Error loading facility data; " + error.message, { timeout: false })
        })
    },
    selectFacility() {
      if (this.$refs.form.validate()) {
        this.multiFacilityDialog = false
        let facility_id = this.selectedFacilityId
        let fclty = this.facilities.find(function(f) {
          return f.facility_id === facility_id
        })
        this.$store.dispatch('changeFacility', { facility: fclty })
      }
    },

    genImg(key, suffix = false) {
      if (typeof key === 'undefined') return
      if (suffix) {
        return '/img/simulate/avatars/' + key + suffix + '.png'
      }
      return '/img/simulate/avatars/' + key + '.png'
    }
  }
}
</script>
